import { CART_TRACKER_TYPE_FOR_V1_AND_V2 } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

export const onTrackCartCodeCreditPointApply = async (payload = {}) => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: CART_TRACKER_TYPE_FOR_V1_AND_V2.CART_CODE_CREDIT_POINT_APPLY,
    data: {
      scope: 'shop',
      event_category: 'Cart',
      ...payload,
    },
  });
};
